import styles from './number-select.module.scss';
import { FormEvent } from 'react';
import { Icon } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface NumberSelectProps { }

interface Props {
  value: number,
  onValueChange: (value: number) => void,
  supportNegative?: boolean,
  max?: number,
  min?: number,
  onBlur?: () => void
}

export function NumberSelect({ value, onBlur, onValueChange, supportNegative, max, min }: Props) {
  const handleMinusClick = () => handleNewValue(value - 1);
  const handlePlusClick = () => handleNewValue(value + 1);
  const handleOnChange = (event: FormEvent<HTMLInputElement>) => {
    handleNewValue(Number(event.currentTarget.value));
  }
  const handleNewValue = (value: number) => {
    const numberValue = Number.isInteger(value) ? value : 0;
    const isNegative = numberValue < 0;
    if (!isNegative || supportNegative) onValueChange(numberValue);
  }
  return (
    <div className={`${styles.numbersSelect} d-flex align-items-center`}>
      <div className={`${styles.num} d-flex align-items-center flex-fill`} onClick={handleMinusClick} >
        <Icon>remove</Icon>
      </div>
      <div>
        <input className={`${styles.number} align-self-center`} value={value} max={max} min={min} onChange={handleOnChange} onBlur={onBlur} />
      </div>
      <div className={`${styles.num} d-flex align-items-center flex-fill`} onClick={handlePlusClick} >
        <Icon>add</Icon>
      </div>
    </div>
  );
}